import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth.store";
import product from "./modules/product.store";
import basket from "./modules/shopping-card.store";
import profile from "./modules/profile.store";
import information from "./modules/information.store";
import settings from "./modules/settings.store";
import statics from "./modules/statics.store";
import sliders from "./modules/sliders.store";
import category from "./modules/category.store";
import filter from "./modules/filter.store";
import search from "./modules/search.store";
import productsList from "./modules/productsList.store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    product,
    basket,
    profile,
    information,
    settings,
    statics,
    sliders,
    category,
    filter,
    search,
    productsList
  }
});
